<script lang="ts">
  import { formatScrap, scrapShare, type TeamStatsView } from '../../game/team-stats';

  interface Props {
    view: TeamStatsView;
    open: boolean;
    ontoggle: () => void;
  }

  const { view, open, ontoggle }: Props = $props();

  const share = $derived(scrapShare(view.blueScrap, view.redScrap));
</script>

<div class="stats" data-testid="team-stats">
  <button
    class="stats__toggle"
    type="button"
    data-testid="team-stats-toggle"
    aria-expanded={open}
    onclick={ontoggle}
  >
    <span class="stats__title">Round stats</span>
    <span class="stats__chevron">{open ? '−' : '+'}</span>
  </button>

  {#if open}
    <table class="stats__grid">
      <thead>
        <tr>
          <th class="stats__corner" scope="col"><span class="stats__sr">Stat</span></th>
          <th class="stats__head stats__head--blue" scope="col">Blue</th>
          <th class="stats__head stats__head--red" scope="col">Red</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th class="stats__label" scope="row">Kills</th>
          <td class="stats__value" data-testid="team-stats-blue-kills">{view.blueKills}</td>
          <td class="stats__value" data-testid="team-stats-red-kills">{view.redKills}</td>
        </tr>
        <tr>
          <th class="stats__label" scope="row">Scrap</th>
          <td class="stats__value" data-testid="team-stats-blue-scrap"
            >{formatScrap(view.blueScrap)}</td
          >
          <td class="stats__value" data-testid="team-stats-red-scrap"
            >{formatScrap(view.redScrap)}</td
          >
        </tr>
      </tbody>
    </table>

    <div class="stats__bar" data-testid="team-stats-bar">
      <div class="stats__bar-blue" style:width="{(share * 100).toFixed(2)}%"></div>
    </div>
    <p class="stats__foot">
      Scrap earned this round<br />not scrap currently held
    </p>
  {/if}
</div>

<style>
  /*
    Left edge under the spectator bar, which is three lines tall from top: 80px. Nothing else
    lives in this column: the scrap plate and the FPS line are gated off for a spectator, and
    the chat log is bottom-anchored.
  */
  .stats {
    position: absolute;
    top: 168px;
    left: 10px;
    width: 244px;
    color: #e6ebf7;
    background:
      repeating-linear-gradient(45deg, rgb(255 255 255 / 5%) 0 2px, transparent 2px 4px),
      linear-gradient(#242423, #171716);
    box-shadow:
      inset 0 1px 0 rgb(255 255 255 / 26%),
      inset 0 -1px 0 rgb(0 0 0 / 60%),
      0 2px 6px rgb(0 0 0 / 70%);
    pointer-events: auto;
  }

  .stats__toggle {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 7px 10px;
    background: none;
    border: none;
    color: inherit;
    font: inherit;
    cursor: pointer;
  }

  .stats__title {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .stats__chevron {
    margin-left: auto;
    font-size: 13px;
    line-height: 1;
    color: #97a0b6;
  }

  .stats__grid {
    width: calc(100% - 20px);
    margin: 0 10px;
    border-collapse: collapse;
    table-layout: fixed;
  }

  .stats__corner {
    width: 68px;
  }

  .stats__sr {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }

  .stats__head {
    padding: 0 0 3px;
    font-size: 10px;
    font-weight: normal;
    text-align: right;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .stats__head--blue {
    color: #8098ff;
  }

  .stats__head--red {
    color: #ff7263;
  }

  .stats__label {
    padding: 2px 0;
    font-size: 10px;
    font-weight: normal;
    text-align: left;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #97a0b6;
  }

  .stats__value {
    padding: 3px 0;
    font-size: 12px;
    text-align: right;
    font-variant-numeric: tabular-nums;
  }

  .stats__bar {
    display: flex;
    height: 4px;
    margin: 9px 10px 0;
    background: #ff7263;
  }

  .stats__bar-blue {
    height: 100%;
    background: #8098ff;
  }

  .stats__foot {
    margin: 6px 0 0;
    padding: 0 10px 9px;
    font-size: 8px;
    line-height: 1.5;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #6c7488;
  }
</style>
